import { render, staticRenderFns } from "./PickupRoadmapIndex.vue?vue&type=template&id=48cb1d11&"
import script from "./PickupRoadmapIndex.vue?vue&type=script&lang=js&"
export * from "./PickupRoadmapIndex.vue?vue&type=script&lang=js&"
import style0 from "./PickupRoadmapIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports